/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ImageContentType = "GIF" | "JPEG" | "PNG" | "WEBP" | "%future added value";
export type GuildPrimaryPhotoNew_guild = {
    readonly rowId: string;
    readonly primaryPhoto: {
        readonly rowId: string;
        readonly contentType: ImageContentType;
    } | null;
    readonly " $refType": "GuildPrimaryPhotoNew_guild";
};
export type GuildPrimaryPhotoNew_guild$data = GuildPrimaryPhotoNew_guild;
export type GuildPrimaryPhotoNew_guild$key = {
    readonly " $data"?: GuildPrimaryPhotoNew_guild$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"GuildPrimaryPhotoNew_guild">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GuildPrimaryPhotoNew_guild",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "primaryPhoto",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contentType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Guild",
  "abstractKey": null
};
})();
(node as any).hash = '99aae2cdb09385030cb83700a3644280';
export default node;
